import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Warn-Dialog: Zurück zur Session-Liste – bestätigen bei laufender Uhr oder vorhandenen Daten.
 */
function BackToSessionsDialog({
  open,
  isRunning,
  currentTimeLabel,
  measurementsCount,
  isSessionNotUploaded,
  onConfirm,
  onCancel
}) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="edit-overlay" onClick={onCancel}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>⚠️ {t('dialog.back_to_sessions.title')}</h3>
          <button className="btn-close" onClick={onCancel} type="button">×</button>
        </div>
        <div className="edit-content">
          <p style={{ fontSize: '1rem', color: '#374151', lineHeight: '1.6' }}>
            {t('dialog.back_to_sessions.message')}
          </p>
          <div className="edit-info">
            {isRunning && currentTimeLabel != null && (
              <div style={{ marginBottom: '8px', fontSize: '0.9rem', color: '#ef4444' }}>
                ⚠️ <strong>{t('dialog.back_to_sessions.running')}</strong> {currentTimeLabel}
              </div>
            )}
            {measurementsCount > 0 && (
              <div style={{ marginBottom: '8px', fontSize: '0.9rem', color: '#ef4444' }}>
                ⚠️ <strong>{t('dialog.back_to_sessions.measurements_present')}</strong> {t('dialog.back_to_sessions.measurements_count', { count: measurementsCount })}
              </div>
            )}
            {isSessionNotUploaded && (
              <div style={{ marginBottom: '8px', fontSize: '0.9rem', color: '#f59e0b' }}>
                ⚠️ <strong>{t('dialog.back_to_sessions.not_uploaded')}</strong> {t('dialog.back_to_sessions.not_uploaded_info')}
              </div>
            )}
            <div style={{ marginTop: '12px', fontSize: '0.9rem', color: '#6b7280' }}>
              {t('dialog.back_to_sessions.session_kept')}
            </div>
          </div>
        </div>
        <div className="edit-actions">
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
          <button className="btn btn-primary" onClick={onConfirm} type="button">
            {t('dialog.back_to_sessions.confirm_button')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BackToSessionsDialog;
